module.exports = __webpack_public_path__ + "img/0f00c63ebaafe56c937d339440619010.png";